var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.newsList.length >= 3
    ? _c(
        "div",
        { staticClass: "news-list-wrap" },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v("\n    更多优质资讯\n  "),
          ]),
          _vm._v(" "),
          _vm._l(_vm.newsList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "news-item act-log",
                class: { "click-style": _vm.isClickArr[index] },
                attrs: {
                  id: "id" + item.adgroup_id,
                  "data-id": "id" + item.adgroup_id,
                  "data-index": index,
                },
                on: {
                  click: function ($event) {
                    return _vm.goDetail(item, index)
                  },
                },
              },
              [
                _c("div", { staticClass: "news-left" }, [
                  _c("div", { staticClass: "news-item-title" }, [
                    _vm._v(_vm._s(item.showTitle)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "left-bottom" }, [
                    _c("span", { staticClass: "news-item-desc" }, [
                      _vm._v(_vm._s(_vm.noticeLabelName(item))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "news-item-desc time" }, [
                      _vm._v(_vm._s(_vm.dateHandle(item.start_time))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "news-right",
                  style: { backgroundImage: `url(${item.showImage})` },
                }),
              ]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }